module.exports = __webpack_public_path__ + "img/residence.d70608df.svg";